// extracted by mini-css-extract-plugin
module.exports = {"star":"AverageRating_star__P9_Ev","averageRating":"AverageRating_averageRating__YL_LD","templatesLength":"AverageRating_templatesLength___rD1M"};